import { f7, useStore } from 'framework7-vue'

import { addVehicle, getAllVehicles } from '@/assets/composables/endpoints'
import { trackParkingVehicleAddSuccess } from '@/assets/composables/events'
import { showPreloader } from '@/assets/composables/preloader'
import type { StoreState, VehicleRequest } from '@/assets/composables/types'
import { notify, processError } from '@/assets/composables/utils'
import store from '@/js/store'

export default class Vehicles {
  constructor() {}

  static async addVehicle(vehicle: VehicleRequest) {
    const closePreloader = showPreloader('Pridávam vozidlo')
    try {
      await addVehicle(vehicle)
      notify('Vozidlo bolo úspešne pridané', () => {
        f7.popup.close('.parking-vehicle-form')
      })

      trackParkingVehicleAddSuccess({
        ecv: vehicle.ecv,
        brand: vehicle.brand,
        model: vehicle.model,
      })
      this.#getVehicles()
    } catch (error) {
      processError(error, 'Nepodarilo sa pridať vozidlo.')
    } finally {
      closePreloader()
    }
  }

  static async #getVehicles() {
    try {
      const vehicles = await getAllVehicles()
      store.dispatch('setVehicles', vehicles)
    } catch (error) {
      processError(error, 'Nepodarilo sa načítať vozidlá.')
    }
  }

  static listVehicles(): StoreState['vehicles'] {
    return useStore('vehicles').value
  }

  static async fetchNewData() {
    await this.#getVehicles()
  }
}
